export default __webpack_public_path__ + "static/img-afterparty-2023-4333e1f51f11e847f10f67919977c047.png";